/**
 * Proposta comercial (impressão → PDF) gerada a partir de um Contrato legado.
 * Fluxo novo: Orçamento → Proposta (módulo Comercial, /propostas/:id). Esta tela permanece para contratos antigos.
 */
import { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import api from "@/lib/api";
import { PageHeader } from "@/components/pcp";
import { PropostaDocumento } from "@/components/comercial/PropostaDocumento";
import { FilePdf, ArrowLeft, FloppyDisk } from "@phosphor-icons/react";
import { toast } from "sonner";
import { baixarPdf } from "@/lib/downloadPdf";

export default function PropostaContrato() {
  const { id } = useParams();
  const [c, setC] = useState(null);
  const [empresas, setEmpresas] = useState([]);
  const [cfg, setCfg] = useState({ empresa_executora_id: "", validade_dias: 30, condicoes_pagamento: "", prazo_execucao: "", observacoes: "" });

  useEffect(() => {
    Promise.all([api.get(`/contratos/${id}`), api.get("/empresas")]).then(([r, e]) => {
      setC(r.data); setEmpresas(e.data);
      setCfg({ empresa_executora_id: r.data.empresa_executora_id || e.data[0]?.id || "", validade_dias: r.data.validade_dias || 30,
               condicoes_pagamento: r.data.condicoes_pagamento || "", prazo_execucao: r.data.prazo_execucao || "", observacoes: r.data.observacoes || "" });
    });
  }, [id]);

  if (!c) return <div className="page-body">Carregando…</div>;
  const emp = empresas.find((e) => e.id === cfg.empresa_executora_id);

  const salvar = async () => {
    const { ordens, qtd_medicoes, ...base } = c;
    try {
      await api.put(`/contratos/${id}`, { ...base, ...cfg, validade_dias: parseInt(cfg.validade_dias) || 30, empresa_executora_id: cfg.empresa_executora_id || null,
        itens: (base.itens || []).map(({ planejado_os, executado, saldo, valor_total, ...i }) => i) });
      toast.success("Dados da proposta salvos no contrato");
    } catch { toast.error("Erro ao salvar"); }
  };

  return (
    <>
      <div>
        <PageHeader testid="page-proposta" title="Proposta Comercial (documento do contrato)" subtitle={`${c.numero} · ${c.contratante}`}
          actions={<>
            <Link to={`/contratos/${id}`} className="btn btn-ghost"><ArrowLeft size={16} weight="bold" /> Voltar</Link>
            <button className="btn btn-outline" onClick={salvar} data-testid="btn-salvar-proposta"><FloppyDisk size={16} weight="bold" /> Salvar dados</button>
            <button className="btn btn-primary" onClick={async () => { await salvar(); baixarPdf(`/contratos/${id}/proposta/pdf`, `Proposta_${c.numero}.pdf`); }} data-testid="btn-proposta-pdf"><FilePdf size={16} weight="bold" /> Baixar PDF</button>
          </>} />
        <div className="page-body" style={{ paddingBottom: 0 }}>
          <div className="pcp-card" style={{ padding: 14, display: "grid", gridTemplateColumns: "1.2fr 0.5fr 1fr 1fr", gap: 12 }} data-testid="proposta-config">
            <div><div className="label">Empresa emitente</div><select className="select" value={cfg.empresa_executora_id} onChange={(e) => setCfg({ ...cfg, empresa_executora_id: e.target.value })} data-testid="prop-empresa"><option value="">— sem empresa —</option>{empresas.map((e) => <option key={e.id} value={e.id}>{e.nome}</option>)}</select></div>
            <div><div className="label">Validade (dias)</div><input type="number" className="input" value={cfg.validade_dias} onChange={(e) => setCfg({ ...cfg, validade_dias: e.target.value })} data-testid="prop-validade" /></div>
            <div><div className="label">Condições de pagamento</div><input className="input" value={cfg.condicoes_pagamento} onChange={(e) => setCfg({ ...cfg, condicoes_pagamento: e.target.value })} placeholder="ex.: medições mensais, 30 dias" data-testid="prop-pagamento" /></div>
            <div><div className="label">Prazo de execução</div><input className="input" value={cfg.prazo_execucao} onChange={(e) => setCfg({ ...cfg, prazo_execucao: e.target.value })} placeholder="ex.: 90 dias após a OS" data-testid="prop-prazo" /></div>
          </div>
        </div>
      </div>
      <PropostaDocumento numero={c.numero} emp={emp} contratante={c.contratante} tipo={c.tipo} objeto={c.objeto} validadeDias={cfg.validade_dias} prazoExecucao={cfg.prazo_execucao} condicoesPagamento={cfg.condicoes_pagamento} observacoes={cfg.observacoes} itens={c.itens} />
    </>
  );
}
